import { render, staticRenderFns } from "./Vuetify.vue?vue&type=template&id=f5d1c06a"
import script from "./Vuetify.vue?vue&type=script&lang=js"
export * from "./Vuetify.vue?vue&type=script&lang=js"
import style0 from "./Vuetify.vue?vue&type=style&index=0&id=f5d1c06a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports